'use strict';

var bsearch = require('binary-search-bounds');

module.exports = classifyFaces;

function FaceIndex(cells, neighbor, constraint, flags, active, next, boundary) {
  this.cells = cells;
  this.neighbor = neighbor;
  this.flags = flags;
  this.constraint = constraint;
  this.active = active;
  this.next = next;
  this.boundary = boundary;
}

var proto = FaceIndex.prototype;

function compareCell(a, b) {
  return a[0] - b[0] || a[1] - b[1] || a[2] - b[2];
}

proto.locate = function () {
  var key = [0, 0, 0];
  return function (a, b, c) {
    var x = a,
        y = b,
        z = c;

    if (b < c) {
      if (b < a) {
        x = b;
        y = c;
        z = a;
      }
    } else if (c < a) {
      x = c;
      y = a;
      z = b;
    }

    if (x < 0) {
      return -1;
    }

    key[0] = x;
    key[1] = y;
    key[2] = z;
    return bsearch.eq(this.cells, key, compareCell);
  };
}();

function indexCells(triangulation, infinity) {
  //First get cells and canonicalize
  var cells = triangulation.cells();
  var nc = cells.length;

  for (var i = 0; i < nc; ++i) {
    var c = cells[i];
    var x = c[0],
        y = c[1],
        z = c[2];

    if (y < z) {
      if (y < x) {
        c[0] = y;
        c[1] = z;
        c[2] = x;
      }
    } else if (z < x) {
      c[0] = z;
      c[1] = x;
      c[2] = y;
    }
  }

  cells.sort(compareCell); //Initialize flag array

  var flags = new Array(nc);

  for (var i = 0; i < flags.length; ++i) {
    flags[i] = 0;
  } //Build neighbor index, initialize queues


  var active = [];
  var next = [];
  var neighbor = new Array(3 * nc);
  var constraint = new Array(3 * nc);
  var boundary = null;

  if (infinity) {
    boundary = [];
  }

  var index = new FaceIndex(cells, neighbor, constraint, flags, active, next, boundary);

  for (var i = 0; i < nc; ++i) {
    var c = cells[i];

    for (var j = 0; j < 3; ++j) {
      var x = c[j],
          y = c[(j + 1) % 3];
      var a = neighbor[3 * i + j] = index.locate(y, x, triangulation.opposite(y, x));
      var b = constraint[3 * i + j] = triangulation.isConstraint(x, y);

      if (a < 0) {
        if (b) {
          next.push(i);
        } else {
          active.push(i);
          flags[i] = 1;
        }

        if (infinity) {
          boundary.push([y, x, -1]);
        }
      }
    }
  }

  return index;
}

function filterCells(cells, flags, target) {
  var ptr = 0;

  for (var i = 0; i < cells.length; ++i) {
    if (flags[i] === target) {
      cells[ptr++] = cells[i];
    }
  }

  cells.length = ptr;
  return cells;
}

function classifyFaces(triangulation, target, infinity) {
  var index = indexCells(triangulation, infinity);

  if (target === 0) {
    if (infinity) {
      return index.cells.concat(index.boundary);
    } else {
      return index.cells;
    }
  }

  var side = 1;
  var active = index.active;
  var next = index.next;
  var flags = index.flags;
  var cells = index.cells;
  var constraint = index.constraint;
  var neighbor = index.neighbor;

  while (active.length > 0 || next.length > 0) {
    while (active.length > 0) {
      var t = active.pop();

      if (flags[t] === -side) {
        continue;
      }

      flags[t] = side;
      var c = cells[t];

      for (var j = 0; j < 3; ++j) {
        var f = neighbor[3 * t + j];

        if (f >= 0 && flags[f] === 0) {
          if (constraint[3 * t + j]) {
            next.push(f);
          } else {
            active.push(f);
            flags[f] = side;
          }
        }
      }
    } //Swap arrays and loop


    var tmp = next;
    next = active;
    active = tmp;
    next.length = 0;
    side = -side;
  }

  var result = filterCells(cells, flags, target);

  if (infinity) {
    return result.concat(index.boundary);
  }

  return result;
}